<template>
<div class="chapter">
<div class="inner_page">
<div class="section">
<div class="header">
<div class="hgroup">
<h3>Prologue</h3>
<h1>The Burning of a Witch</h1>
</div>
</div>
<p class="triple" style="text-align: center;">
<strong>A.​D. 1490</strong></p>
<p class="first">
<span style="font-size: 1em; line-height: 1.5; text-indent: 1.5em;">It took sixteen loads of peat and fifty bundles of fresh green wood to burn a witch.</span></p>
<p style="text-align:justify">
	“When it’s green,” the Guardian explained to the boy, “it burns longer.”</p>
<p style="text-align:justify">
	Men with shirtsleeves rolled up their hairy arms were laying the wood around the stake. The square was thronged with people cheering them on in their task. The execution of traitors, after all, was always a great public occasion, and a burning at the stake was the most festive of all. All around the bedazzled boy, vendors in silly jester’s hats hawked roasted chestnuts and steaming fried apples. Spider monkeys turned somersaults while their owners played merry little tunes upon their lutes.</p>
<p style="text-align:justify">
	“There!” someone from the crowd called out. “There she comes!”</p>
<p style="text-align:justify">
	A shout rose up as the cart carrying the witch trundled into view over the cobblestone road. “Burn the she-devil! Burn the witch! <i>Burn! Burn! Burn</i>!”</p>
<p style="text-align:justify">
	The boy turned, his eyes wide.</p>
<p style="text-align:justify">
	But Isobel the Apostate looked back at all of them with only a cold, quiet disdain. Her black eyes flashed as the crowd parted to make way for her cart. Strong men fell to the ground at the sight of her, overcome by her terrible beauty. If not for her wrists being bound by that strange golden chain, the boy knew they would all be in great danger. Yet bound as she was, the witch could no longer harm them, no longer summon the demons from the Hell Hole to do her bidding, the demons which would terrorize the villages of northeastern England no more.</p>
<p style="text-align:justify">
	Her green velvet dress was torn and soiled. Her black hair was loose, tumbling down to her waist in great disarray. Once, Isobel the Apostate was a noble lady with a vast estate who claimed descent from the blood royal, who dared to quarter her arms with those of King Henry the Fourth. For such audacity alone, the judges decreed she should die.</p>
<p style="text-align:justify">
	But there were sins far worse than treason.</p>
<p style="text-align:justify">
	“Look, over there,” the boy’s Guardian pointed out to him. “Do you see that man? The one with no legs, propped in the chair? ’Twas under his home that the witch discovered the Hell Hole. Without any regard to him who lived there, she opened the portal between this world and the one below.” The Guardian paused. “You see the result. The man is fortunate. His wife and sons did not survive the cataclysm.”</p>
<p style="text-align:justify">
	“But the golden chain…?”</p>
<p style="text-align:justify">
	“It has the power to keep her from escaping, from turning all of us here into toads and rats and skunks.” The Guardian lifted his eyes to the gray, cloudy sky. “At least, I pray that it does. I pray that the noble Sorcerers of the Nightwing, God be praised, have at last found the means to contain her.”</p>
<p style="text-align:justify">
	The boy watched as the witch was led from her cart to the center of the square. The crowd surged forward. Insults and curses rained down upon the woman, whose neck now began to snap back and forth, finally reacting to the taunts of the crowd. Her teeth gnashed wildly. She growled, hissing like a cat cornered by a pack of angry dogs.</p>
<p style="text-align:justify">
	“Get up there, boy,” the Guardian told him. “You must bear witness.”</p>
<p style="text-align:justify">
	Two platforms stood to the right of the square. They were filled with men from the King’s Court. Statesmen and clerics. The Archbishops of York and Canterbury. The Duke of Norfolk. They had all come to see the destruction of Isobel the Apostate, the most feared sorceress in all of Europe, a lady whose courtiers were not knights and gentlemen but the very beasts of hell.</p>
<p style="text-align:justify">
	Shoved toward the pillory by her guards, Isobel was forced onto her knees to face her judges. A pointed hat was placed on her head, on which is inscribed the words: Heretic, Witch, Apostate. Her death sentence was proclaimed, and a cheer rose from the crowd.</p>
<p style="text-align:justify">
	“Will she be allowed to speak?” the boy asked, looking up at his Guardian.</p>
<p style="text-align:justify">
	“Oh, no. For all that the last words of the condemned have long been a tradition in this realm, Isobel the Apostate is far too dangerous a prisoner. Even secured by the golden chain, what terrible catastrophe might she bring down upon us with her final words?”</p>
<p style="text-align:justify">
	But though she might be denied speech, the witch could still scream.</p>
<p style="text-align:justify">
	It was a horrible sound, and many in the crowd covered their ears. The witch’s screams echoed like those of a banshee off the walls of the square. Forcibly she was led to the pyre, snarling and twisting all the way.</p>
<p style="text-align:justify">
	“It wasn’t supposed to end like this, you see,” the Guardian explained, leaning down and whispering to the boy. “It was supposed to end with Isobel crowned as Queen of England. From there, with the English navy at her command, it would have been an easy step for her to rule the world, the demons of the Hell Hole at her side.”</p>
<p style="text-align:justify">
	The boy watched as the witch was pushed up the steps of the platform to the stake.</p>
<p style="text-align:justify">
	“But twas her own kind who turned her over to the King. Her own Nightwing brethren looked upon her evil and trapped her. It was they, far more than any of the King’s men, who consigned her to this fate. And do you know why it was done so, boy?”</p>
<p style="text-align:justify">
	The boy’s eyes remained riveted on the witch.</p>
<p style="text-align:justify">
	“Because true power can never be found through the pursuit of evil,” the boy replied, never removing his gaze. “True power comes only from good.”</p>
<p style="text-align:justify">
	His Guardian smiled.</p>
<p style="text-align:justify">
	“Yes, boy. You have learned well. You will make a noble sorcerer. Now watch. And learn from the death of the Apostate.”</p>
<p style="text-align:justify">
	Isobel was tied to the stake with the same kind of golden chain that bound her wrists. Her black eyes continued to flash, looking at each and every face in the crowd, as if committing them all to memory.</p>
<p style="text-align:justify">
	Her gaze fell upon the boy.</p>
<p style="text-align:justify">
	He gasped, pulling back from the power he saw there.</p>
<p style="text-align:justify">
	Her eyes danced as she took in the sight of him. She laughed, a cackle the boy would not soon forget. On his shoulder the grip of his Guardian tightened. “Fear her not,” the Guardian whispered. “Her time has come.”</p>
<p style="text-align:justify">
	The executioner lit the wood piled up around the base of the stake. Once more, Isobel the Apostate screamed.</p>
<p style="text-align:justify">
	“Think not that I perish here!” the witch cried out into the crowd, defying the order against speech. “Think not that you have won!”</p>
<p style="text-align:justify">
	The boy felt his Guardian’s hand tremble.</p>
<p style="text-align:justify">
	“<i>This is not the end of Isobel!”</i></p>
<p style="text-align:justify">
	The flames sprung into roaring life, caught by the peat. Like malevolent imps, they popped and crackled and jumped upward. A spark ignited the witch’s dress.</p>
<p style="text-align:justify">
	“She burns!” someone in the crowd shouted.</p>
<p style="text-align:justify">
	The fire below her grew in heat and intensity. It was so strong that even several feet away the boy and his Guardian could feel it on their faces. Thick sheets of pitchy smoke appeared, obscuring their view. Soon the whole square was as black as night, and the crowd began coughing, turning away from the pyre. The foul stench of burning flesh assaulted their senses. From the heart of the darkness the witch screamed again. It was taken by many as her cry of death.</p>
<p style="text-align:justify">
	“So must perish all of the King’s enemies!” proclaimed the executioner.</p>
<p style="text-align:justify">
	But then the wind shredded the smoke, and there was a glimpse of the witch. The boy could see her, with her arms upstretched, free of her chains, as the flames consumed her body. Her eyes were wide and she was smiling.</p>
<p style="text-align:justify">
	“Does she perish?” the boy asked his Guardian, tugging at his robe. “Does she really perish?”</p>
<p style="text-align:justify">
	The Guardian did not reply.</p>
<p style="text-align:justify">
	Later, when the flames had died down, there was nothing left of the body of Isobel the Apostate. The King’s men declared that so great was the fire that the witch was consumed completely, reduced to mere cinder and ash.</p>
<p style="text-align:justify">
	But the Nightwing knew better.</p>
<p style="text-align:justify">
	For the boy reported to them that as he watched, the witch transformed herself into a great bird, a creature of gold with a tremendous wingspan that rose majestically above the flames with a resounding call of triumph. Then the bird diffused with the smoke, disappearing into the gray skies over the square.</p>
<p style="text-align:justify">
	“Like a phoenix,” the boy’s Guardian said, a great and shattering awe in his voice, “Isobel the Apostate has risen from the flames to live again.”</p>
<p>
</p>
<div style="page-break-after: always;">
<div style="display: none;">
</div>
</div>
<h2 style="text-align: center;">
	Nearly Five Hundred Years Later</h2>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap149088.vue?1c6955c9